/**
 * Utility functions to manage Closer types
 * @public
 */
export var Closer;
(function (Closer) {
    /** Combine multiple closers */
    function combine(...closers) {
        return () => {
            for (const closer of closers) {
                closer();
            }
        };
    }
    Closer.combine = combine;
})(Closer || (Closer = {}));
//# sourceMappingURL=Closer.js.map